export const APPEARED_IN_TITLE = 'Appeared in';
export const RIGHT_RAIL_TITLE = 'Related Data Visuals';

export const FALLBACK_IMAGE_CLASS = 'graphics__fallback-image';
export const FALLBACK_IMAGE_LOADED_CLASS = 'is-loaded';

export const FLOURISH_SCRIPT_URL = 'https://public.flourish.studio/resources/embed.js';
export const FLOURISH_EMBED_SELECTOR = '.flourish-embed';

export enum GraphicSource {
  Datawrapper = 'datawrapper',
  Flourish = 'flourish',
  StaticImage = 'static_image',
  SelfHosted = 'self_hosted',
}
